// RoutQcisStat - 중간검사 현황
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useAuth } from '../../../../../contexts/auth';
import { PagingGrid } from '../../../../script/components/data-grid/data-grid-body/grid-bodys';
import { BoolCol, CommCol, DateCol, DeciCol } from '../../../../script/components/data-grid/data-grid-column/grid-column';
import { fwUtil } from '../../../../script/util';
import { FwAppLoader } from '../../../../script/components/load-panel/load-panel';

export default function RoutQcisStat(props) {
    const {
        acce, gubu, cata, catb, code,
        mainTitle, mainRole, 
    } = props; 

    // api
    const searchApi = `${acce}/${gubu}/${cata}/${catb}/inspect/status/search`;  // 조회 api    
    // 시스템
    const [loading, setLoading] = useState(true);
    // 권한
    const { authCheck } = useAuth();
    const [authList, setAuthList] = useState([]);
    // 그리드
    const gridSize = 'single';
    const mainKey = 'insp_numb';
    const mainGridRef = useRef(null);
    const [mainGridData, setMainGridData] = useState([]);
    const mainGridDataUpdate = useCallback((e) => setMainGridData(e), []);        
    // 검색 조건
    const [dateValue, setDateValue] = useState(fwUtil.date.getsText.range());
    const [duraYesn, setDuraYesn] = useState(true);
    const [inspNumb, setInspNumb] = useState("");
    const [workNumb, setWorkNumb] = useState("");
    const dateValueChange= useCallback((e) => { setDateValue([e.value[0], e.value[1]]) }, []);
    const duraYesnChange = useCallback((e) => { setDuraYesn(e.value) }, []);
    const inspNumbChange = useCallback((e) => { setInspNumb(e) }, []);
    const workNumbChange = useCallback((e) => { setWorkNumb(e) }, []);

    // 조회
    const mainHandleSearch = useCallback(async () => {
        const sendData = { start: dateValue[0], compl: dateValue[1], duraYesn: duraYesn, inspNumb: inspNumb, workNumb: workNumb };        
        await fwUtil.apis.search(searchApi, sendData, mainGridDataUpdate);
    }, [dateValue, duraYesn, inspNumb, workNumb, mainGridDataUpdate, searchApi]);

    useEffect(() => {
        mainHandleSearch();
    }, [mainHandleSearch]);

    // 접근 권한 조회 및 권한 상태값 설정
    useEffect(() => {
        authCheck(setLoading, setAuthList, gubu, code);
    }, [authCheck, setLoading, setAuthList, gubu, code]);

    // 추가 툴바 아이템
    const toolbarItems = useMemo(() => [
        { type: 'text', locate: 'before', caption: '검사번호', value: inspNumb, valueChange: inspNumbChange, search: mainHandleSearch },
        { type: 'text', locate: 'before', caption: '작업지시번호', value: workNumb, valueChange: workNumbChange, search: mainHandleSearch },
        { type: 'btns', locate: 'before', icon: 'search', text: '검색', onClick: mainHandleSearch },
    ], [inspNumb, inspNumbChange, workNumb, workNumbChange, mainHandleSearch]);

    return (
        <div className='fw-grid-page fw-flex-box col'>
            <FwAppLoader loading={loading} />
            <PagingGrid
                title={mainTitle}
                role={mainRole}
                gridSize={gridSize}
                mainKey={mainKey}
                gridRef={mainGridRef}
                gridDataSource={mainGridData}
                dateValue={dateValue}
                dateValueChange={dateValueChange}
                duraYesn={duraYesn}
                duraYesnChange={duraYesnChange}
                exp={{ disabled: authList.auth_dnlo === 0 }}
                toolbar={{ default: true, items: toolbarItems }}
                selection={'single'}
            >
                {CommCol({ dataField: "insp_numb", caption: "검사번호" })}
                {CommCol({ dataField: "insp_gubu", caption: "검사구분" })}
                {CommCol({ dataField: "work_numb", caption: "작업지시번호" })}
                {CommCol({ dataField: "item_code", caption: "품번" })}
                {CommCol({ dataField: "item_name", caption: "품명" })}
                {CommCol({ dataField: "rout_numb", caption: "공정번호" })}
                {CommCol({ dataField: "rout_name", caption: "공정명" })}
                {DeciCol({ dataField: "insp_qtys", caption: "검사수량" })}
                {DeciCol({ dataField: "judg_qtys", caption: "판정수량" })}
                {CommCol({ dataField: "damd_name", caption: "검사자" })}
                {DateCol({ dataField: "insp_date", caption: "검사일자" })}
                {BoolCol({ dataField: "judg_yesn", caption: "불합격여부" })}
                {BoolCol({ dataField: "infe_ca01", caption: "불량원인:소재", width: 160 })}
                {BoolCol({ dataField: "infe_ca02", caption: "불량원인:치수", width: 160 })}
                {BoolCol({ dataField: "infe_ca03", caption: "불량원인:외관", width: 160 })}
                {BoolCol({ dataField: "infe_ca04", caption: "불량원인:셋팅", width: 160 })}
                {BoolCol({ dataField: "infe_ca05", caption: "불량원인:탭/나사", width: 160 })}
                {BoolCol({ dataField: "infe_ca06", caption: "불량원인:전/후처리", width: 180 })}
                {BoolCol({ dataField: "infe_ca07", caption: "불량원인:기타", width: 160 })}
                {CommCol({ dataField: "ca07_memo", caption: "불량원인:기타사유" })}
                {CommCol({ dataField: "insp_memo", caption: "비고" })}
            </PagingGrid>              
        </div>
    );
};